import { Delete } from '@mui/icons-material';
import {
    Alert,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Typography,
} from '@mui/material';
import React, { useState } from 'react';

export default function DeleteTag({ data, handleSubmit }) {
  const [error, setError] = useState(null);
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);

  const handleDelete = async () => {
    await handleSubmit('delete', data.id);
  };

  const handleDeleteButtonClick = () => {
    setDeleteConfirmationOpen(true);
  };

  const handleDeleteConfirm = () => {
    handleDelete();
    setDeleteConfirmationOpen(false);
  };

  const handleDeleteCancel = () => {
    setDeleteConfirmationOpen(false);
  };

  return (
    <>
      <IconButton
        variant="text"
        color="error"
        title="Delete"
        sx={{ cursor: 'pointer', textTransform: 'none', fontSize: 'inherit' }}
        onClick={handleDeleteButtonClick}>
        <Delete />
      </IconButton>
      <Dialog
        open={deleteConfirmationOpen}
        onClose={handleDeleteCancel}
        fullWidth
        maxWidth="xs">
        <DialogTitle>Confirmation</DialogTitle>
        <DialogContent>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          <Typography>
            Are you sure you want to delete <strong>{data.name}</strong>?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancel} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDeleteConfirm} color="secondary">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
